<template>
  <div>
    <h3>Отлично!</h3>
    <!--    <h3>{{ success ? 'Правильно!' : 'Не вышло!' }}</h3>-->
    <!--    <p>{{ success ? 'Дракоша найден!' : 'Дракоша смог от тебя спрятаться! Попробуй еще разок!' }}</p>-->
    <p class="scores">И ты зарабатываешь
      <strong>{{ scores }}</strong> {{ $root.getNoun(scores, 'балл', 'балла', 'баллов') }}!</p>
    <p>Попробуем еще разок?</p>
    <button class="uk-button uk-button-primary" @click="$emit('onStartGame')" v-if="!checkFinishHomework()">Повторить!</button>
    <button class="uk-button uk-button-primary" @click="$emit('onStopGame')" v-else>Закончить</button>
  </div>
</template>

<script>
import { mix } from "./../../mixin";

export default {
  name: "finish",
  data() {
    return {}
  },
  mixins: [
    mix
  ],
  props: {
    success: '',
    scores: ''
  },
  methods: {}
}
</script>